export const permissionGroup = {
  ADMIN: 'admin',
  USERS: 'users',
  ROLES: 'roles'
};
export const permissionTypes = {
  ADMIN: 'admin',
  READ: 'read',
  UPDATE: 'update',
  CREATE: 'create',
  DELETE: 'delete',
};
export const permissions = {
  ADMIN_ADMIN: 'admin:admin',
  USERS_READ: 'users:read',
  USERS_UPDATE: 'users:update',
  USERS_CREATE: 'users:create',
  USERS_DELETE: 'users:delete',
  ROLES_READ: 'roles:read',
  ROLES_UPDATE: 'roles:update',
  ROLES_CREATE: 'roles:create',
  ROLES_DELETE: 'roles:delete',
  LOGS_READ: 'logs:read',
  LOGS_CREATE: 'logs:create',
  LOGS_DELETE: 'logs:delete',
  COW_READ: 'cow:read',
  COW_UPDATE: 'cow:update',
  COW_CREATE: 'cow:create',
  COW_DELETE: 'cow:delete',
  SUPPLIER_ORDERS_CREATE: 'supplier_orders:create',
  ARTICLES_READ: 'articles:read',
  ARTICLES_UPDATE: 'articles:update',
  ARTICLES_CREATE: 'articles:create',
  ARTICLES_DELETE: 'articles:delete',
  PRINTER_READ: 'printer:read',
  PRINTER_UPDATE: 'printer:update',
  PRINTER_CREATE: 'printer:create',
  PRINTER_DELETE: 'printer:delete',
  JOBS_READ: 'jobs:read',
  JOBS_UPDATE: 'jobs:update',
  JOBS_CREATE: 'jobs:create',
  JOBS_DELETE: 'jobs:delete',
};
